import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { allIcons, allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import { useNavigate } from "react-router-dom";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_faq_gr": {
    fontWeight: 700,
    fontSize: "1.5rem",
    background: "linear-gradient(90deg, #EA580C 0%, #000000 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },

  // "& .lpl_mobile_img":{
  //     [theme.breakpoints.down("sm")]: {
  //       w: "2rem",
  //     },
}));

const data = [
  "Small fee on each successful booking",
  "No monthly subscriptrion",
  "Real-time earning reports",
];

function FeesSections() {
  const navigate = useNavigate();
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container spacing={2} alignItems={"center"}>
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_faq_gr">
            Fee Charges
          </Typography>
          <Typography
            variant="body1"
            fontSize={"1.125rem"}
            fontWeight={500}
            lineHeight={1.7}
          >
            We charge a small fee of 10 SAR per booking to ensure smooth,
            secure, and reliable transactions for both salons and clients. This
            commission supports platform security, appointment tracking,
            automated reminders, and dedicated customer support. It also fuels
            our continuous improvement to offer a top-tier B2B experience that
            grows your business effortlessly.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} display={"flex"} justifyContent={"center"}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h1"
                className="lpl_faq_gr"
                textAlign={"center"}
              >
                Transparent Pricing & Fair Commission
              </Typography>
              <Typography
                variant="body1"
                fontSize={"1.125rem"}
                fontWeight={500}
                lineHeight={1.7}
                textAlign={"center"}
              >
                Only pay when you earn - no hidden fees.
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              display={"flex"}
              justifyContent={"center"}
            >
              <img
                src={allImages.feesImage}
                alt="mobile-screen"
                width="70%"
                style={{ objectFit: "contain" }}
                className="lpl_mobile_img"
              />
            </Grid>
            <Grid item xs={12} md={6} p={5}>
              {data?.map((item) => {
                return (
                  <Box display={"flex"} mt={1}>
                    <img
                      src={allIcons.checkSquareIcon}
                      alt="mobile-screen"
                      width="9%"
                      height="9%"
                      style={{ marginTop: 4 }}
                    />
                    <Typography
                      variant="body1"
                      fontSize={"0.93rem"}
                      lineHeight={1.7}
                      ml={1}
                    >
                      {item}
                    </Typography>
                  </Box>
                );
              })}
              <Stack mt={2}>
                <GlobalButton
                  btnText={"See How It Works"}
                  handleClickBtn={() => navigate("/login")}
                />
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </MainView>
  );
}

export default FeesSections;
